module.exports = __webpack_public_path__ + "static/img/discussion_member_04_ph.aefc50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/discussion_member_04_ph.png
// module id = mDpy
// module chunks = 0